import {
    type OpenApiGetPromosResponseSuccess,
    type OpenApiGetPromosSearchParams,
    type OpenApiSchemaPromo,
} from '#shared/api/schema';
import { createPaginateDataGridProvider } from '#shared/components/grid';
import { promosApi, promosGridTagInvalidator, type PromosTag } from '../../api/promosApi';

export const useDiscountPromosDataGridProvider = createPaginateDataGridProvider<
    OpenApiSchemaPromo,
    OpenApiGetPromosSearchParams,
    OpenApiGetPromosResponseSuccess,
    typeof PromosTag
>({
    getPageNumber: (params) => params.page ?? 1,
    getPerPage: (params) => params.per_page ?? 25,
    getTotal: (result) => result.total_count,
    getRows: (result) =>
        result.promos.map((item) => {
            return { id: item.id, attributes: item };
        }),
    getItemFromRow: (row) => row.attributes,
    endpoint: promosApi.endpoints.getList,
    invalidateTagHelper: promosGridTagInvalidator,
});
